import d from "../helpers/services/webcoreService/webcoreService.js";
import { useState as r, useEffect as g } from "react";
const c = new d();
function p(s = !0, o = !0, t = "prod") {
  const [a, i] = r(), [f, n] = r(!1), [u, m] = r();
  return g(() => {
    s && (async () => {
      t && c.setEnvironment(t), n(!0);
      try {
        const e = await c.getMegaMenuItems(o);
        i(e);
      } catch (e) {
        console.error(e), m(e);
      }
      n(!1);
    })();
  }, [s, t, o]), { items: a, isLoading: f, error: u };
}
export {
  p as default
};
